import React, { useCallback, useMemo } from 'react';
import { WorkFromHomeIcon } from '@kallidus/common';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useTryAgainErrorButton from './useTryAgainErrorButton';

const useStandardErrorButtons = (reset) => {
  const { t } = useTranslation();
  const tryAgainErrorButton = useTryAgainErrorButton(reset);

  const { push } = useHistory();
  const handleClick = useCallback(() => {
    push('/');
    reset();
  }, [push, reset]);

  return useMemo(
    () => [
      tryAgainErrorButton,
      {
        isPrimary: false,
        label: t('error-page.go-home', 'Go home'),
        onClick: handleClick,
        iconStart: <WorkFromHomeIcon />,
      },
    ],
    [tryAgainErrorButton, handleClick, t],
  );
};

export default useStandardErrorButtons;
